/**
 * Author: Claude Code
 * Version: v3.2.17
 * Modified: 2025-10-03
 *
 * LiveChatPanel - 实时聊天面板（参考page.tsx）
 */

import React, { useState, KeyboardEvent } from 'react';

export interface ChatMessage {
  user: string;
  message: string;
  timestamp: string;
}

export interface LiveChatPanelProps {
  isVisible: boolean;
  onClose?: () => void;
}

export const LiveChatPanel: React.FC<LiveChatPanelProps> = ({ isVisible, onClose }) => {
  const [chatMessage, setChatMessage] = useState('');
  const [chatMessages, setChatMessages] = useState<ChatMessage[]>([
    { user: 'Player1', message: 'Agent Alpha looking strong!', timestamp: '15:20:00' },
    { user: 'Spectator', message: 'This is intense!', timestamp: '15:20:15' },
    { user: 'Player2', message: 'My agent is in trouble...', timestamp: '15:20:30' }
  ]);

  const sendMessage = () => {
    if (chatMessage.trim()) {
      const newMsg: ChatMessage = {
        user: 'You',
        message: chatMessage,
        timestamp: new Date().toLocaleTimeString()
      };
      setChatMessages([...chatMessages, newMsg]);
      setChatMessage('');
    }
  };

  const handleKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      sendMessage();
    }
  };

  if (!isVisible) return null;

  return (
    <div className="expanded-panel chat-panel">
      <div className="panel-header">
        <h3>💬 Live Chat</h3>
        {onClose && (
          <button className="close-btn" onClick={onClose}>✕</button>
        )}
      </div>
      <div className="panel-body">
        <div className="chat-messages">
          {chatMessages.map((msg, i) => (
            <div key={i} className="chat-line">
              <span className="chat-user">{msg.user}:</span>{' '}
              <span className="chat-text">{msg.message}</span>
            </div>
          ))}
        </div>
        <div className="chat-input-group">
          <input
            className="chat-input"
            placeholder="Type message..."
            value={chatMessage}
            onChange={(e) => setChatMessage(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <button className="send-btn" onClick={sendMessage}>
            Send
          </button>
        </div>
      </div>
    </div>
  );
};
